







import { Component, Vue } from "vue-property-decorator";
import pc from "./pc/index.vue";
import mb from "./mb/index.vue";
@Component({
  components: { pc, mb },
})
export default class Home extends Vue {
  public isMbShow = false;
  public created() {
    if (this.isMobile()) {
      this.isMbShow = true;
    } else {
      this.isMbShow = false;
    }
  }
  public isMobile() {
    const flag = navigator.userAgent.match(
      /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    return flag;
  }
}
